export const SUBJECT_ID_BY_LABEL = {
  Art: "art",
  Chemistry: "chemistry",
  English: "english",
  "Graphic Design": "graphic_design",
  Maths: "maths",
  Physics: "physics",
  Psychology: "psychology",
  Spanish: "spanish",
};
export function toId(value) {
  if (!value) return "general";

  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
}
